// extracted by css-extract-rspack-plugin
export default {"userInfo":"Profile_userInfo__wCTBK","buttonPadding":"Profile_buttonPadding__V4-WB","page":"Profile_page__yza6P","bottomWrapper":"Profile_bottomWrapper__Zga-n"};